export const RAC_LOG_STAMP = "RAC DARK LAUNCH";

// TODO: DELETE ME
export enum ReturnTotalsType {
  LEGACY = "legacy",
  NEW = "new",
}
